import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const axiosConfig = {
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
};

const handleAxiosError = (err, rejectWithValue) => {
    if (err.message === "Network Error") {
        return rejectWithValue({ message: "Network Error" });
    }
    return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
    );
};

export const createCertificateType = createAsyncThunk(
    "certificateType/createCertificateType",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${PUBLIC_BASE_URL}/certificate-types/create-certificate-type`,
                formData,
                axiosConfig
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getAllCertificateTypes = createAsyncThunk(
    "certificateType/getAllCertificateTypes",
    async ({ skip, limit, search }, { rejectWithValue }) => {
        try {

            const params = {
                ...(skip != null && { skip }),
                ...(limit != null && { limit }),
                ...(search?.trim() && { search }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-types`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const updateCertificateType = createAsyncThunk(
    "certificateType/updateCertificateType",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axios.put(
                `${PUBLIC_BASE_URL}/certificate-types/update-certificate-type-info`,
                formData,
                axiosConfig
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getActiveCertificateTypes = createAsyncThunk(
    "certificateType/getActiveCertificateTypes",
    async (_, { rejectWithValue }) => {
        try {

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-types/active-certificate-types`,
                {
                    ...axiosConfig,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);